import { createFileRoute } from '@tanstack/react-router'
import { SchoolBillingClient } from '../components/SchoolBillingClient'

export const Route = createFileRoute('/school/$schoolId/billing')({
  head: () => ({
    meta: [{ title: 'School Billing | Unbreakable' }],
  }),
  component: SchoolBillingPage,
})

function SchoolBillingPage() {
  return <SchoolBillingClient />
}
